import PropTypes from 'prop-types'
import React from 'react'
import { useSelector } from 'react-redux'
import _get from 'lodash/get'
import Link, { TARGET_BLANK } from '../../Link/index'
import { useTranslation } from '../../../services/static-text/hooks'
import { get as getConfig } from '../../../config/index'
import { getGiftTermsAndConditionsUrl } from '../../../services/url/index'
import { selectPrimaryLanguage } from '../../../services/user/selectors'
import Sherpa, { TYPE_SMALL_WHITE, TYPE_LARGE } from '../../Sherpa/index'
import { H1, HEADING_TYPES } from '../../Heading/index'
import { GIFT_CREATE_PAGE_STATIC_KEY as staticTextStoreKey } from '../GiftCreatePage/gift-create-page-static-key'
import { URL_GIFT_TERMS_AND_CONDITIONS } from '../../../services/url/constants'

const config = getConfig()
const giftMultipleCurrenciesActive = !!_get(config, ['features', 'gift', 'multipleCurrencies'])

const GiftLayoutPropTypes = {
  pageTitle: PropTypes.string.isRequired,
  columnReverse: PropTypes.bool,
  pageReady: PropTypes.bool,
  rightSide: PropTypes.node,
  main: PropTypes.node,
}

/**
 * @type {React.FC<PropTypes.InferProps<GiftLayoutPropTypes>>}
 * @returns {React.ReactElement}
 * */
export const GiftLayout = ({
  columnReverse,
  description,
  processing,
  restricted,
  pageReady,
  pageTitle,
  rightSide,
  main,
  bottom,
}) => {
  const restrictedClass = (restricted && ' gift-layout--restricted') || ''
  const reverseClass = (columnReverse && ' gift-layout--col-rev') || ''
  const translateByKey = useTranslation(staticTextStoreKey)
  const userLanguage = useSelector(selectPrimaryLanguage)

  return (
    <div className={`gift-layout${restrictedClass}${reverseClass}`}>
      {!pageReady ? (
        <Sherpa type={TYPE_SMALL_WHITE} className={['gift-layout__sherpa']} />
      ) : (
        <>
          {processing ? <Sherpa type={TYPE_LARGE} className={['gift-layout__sherpa-overlay']} /> : null}
          <H1
            as={[HEADING_TYPES.H3_MOBILE, HEADING_TYPES.H1_DESKTOP]}
            className="gift-layout__title"
          >
            {pageTitle}
          </H1>
          {description
            ? <div className="gift-layout__description">{description}</div>
            : null}
          <div className="gift-layout__stars-mobile"></div>
          <div className="gift-layout__container">
            <div className="gift-layout__item">{rightSide}</div>
            <div className="gift-layout__item">{main}</div>
          </div>
          {bottom}
          <div className="gift-layout__footer">
            <p className="gift-layout__terms-and-conditions">
              {translateByKey('termsAndConditionsStart')}
              <Link
                to={
                  giftMultipleCurrenciesActive
                    ? getGiftTermsAndConditionsUrl(userLanguage)
                    : URL_GIFT_TERMS_AND_CONDITIONS
                }
                target={TARGET_BLANK}
              >{translateByKey('termsAndConditionsLink')}
              </Link>
              {translateByKey('termsAndConditionsEnd')}
            </p>
          </div>
        </>
      )}
    </div>
  )
}

GiftLayout.propTypes = GiftLayoutPropTypes

export default GiftLayout
